<template>
    <aside id="left-sidebar">
        <div class="logo-container d-flex justify-content-center align-items-center">
            <img src="@/assets/img/IN.svg" alt="" />
        </div>
        <div class="sidebar-list">
            <div
                v-for="(item, index) in options"
                :key="index"
                @click="() => sidebarItemClicked(item.action, index)"
                :id="'item-' + index"
                class="mb-1"
                :class="[item.type == 'item' ? 'list-item d-flex justify-content-center align-items-center' : 'divider', item.active ? 'active' : '']"
            >
                <div :class="item.type == 'divider' ? 'line' : 'd-flex justify-content-center align-items-center'">
                    <icon v-if="item.type == 'item'" :name="item.name" color="var(--secondary-3)" />
                </div>
                <b-tooltip
                    v-if="item.type == 'item' && item.tooltipText"
                    :target="'item-' + index"
                    ref="tooltip"
                    placement="right"
                    variant="light"
                    noninteractive
                >
                    <p class="text-14 mb-0 text-primary-3">{{ item.tooltipText }}</p>
                </b-tooltip>
            </div>

            <div v-if="openQuitViewerDialog" class="quit-viewer-dialog">
                <div class="content">
                    <p class="text-10 text-weight-bold mb-1 text-center">{{ $t('Components_Viewer_Sidebar_LeftSidebar_1') }}</p>
                    <p class="text-10 mb-1 text-secondary-3 text-center">
                        {{ $t('Components_Viewer_Sidebar_LeftSidebar_2') }}
                    </p>
                </div>
                <div class="footer">
                    <div class="dialog-btn" @click="onCancelExit">
                        <p class="text-10 text-secondary text-center">{{ $t('cancel') }}</p>
                    </div>
                    <div class="btns-border"></div>
                    <div class="dialog-btn" @click="exitViewer">
                        <p class="text-10 text-secondary text-center">{{ $t('button_text16') }}</p>
                    </div>
                </div>
            </div>
        </div>
    </aside>
</template>

<script>

// ====================
// Icons
// ====================
import 'vue-awesome/icons/door-open'
import 'vue-awesome/icons/map'
import 'vue-awesome/icons/layer-group'
import 'vue-awesome/icons/comment-dots'
import 'vue-awesome/icons/chevron-left'

/**
 * @param {Boolean} isOpen
 * @param {Array} options - [{type (item/divider), name (icon name), action (emitName), tooltipText}]
 */

export default {
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        options: Array,
    },
    data() {
        return {
            openQuitViewerDialog: false,
            onCancelExitCallback: null,
        }
    },
    methods: {
        sidebarItemClicked(action, index) {
            this.$emit(action, !this.isOpen)
        },

        showExitDialog(onCancelExitCallback = null) {
            this.openQuitViewerDialog = true
            this.onCancelExitCallback = onCancelExitCallback
        },

        onCancelExit() {
            this.openQuitViewerDialog = false

            if (this.onCancelExitCallback) {
                this.onCancelExitCallback()
            }
        },

        exitViewer() {
            window.location.href = 'https://constructin.com.br'
        },
    },
}
</script>

<style lang="scss">
@import '@/scss/components/360Viewer/Sidebar/left-sidebar-global.scss';
</style>

<style lang="scss" scoped>
@import '@/scss/components/360Viewer/Sidebar/left-sidebar.scss';
</style>
